export default "__VITE_ASSET__lYpbdsRe__"